/**
 * @file editopic-mutations.js
 */

import toast from '@/utils/decorate/toast';
import {Tip} from '@/utils/errorCode';

export default {
    // 随长度改变标题
    changeTitleLength(state, maxlen) {
        // 如果超过最大长度，标题内容截断
        // 场景：从Issue切换到其他板块
        if (state.titleConfig.defaultValue.length > maxlen) {
            let outLenVal = state.titleConfig.defaultValue;
            state.titleConfig.defaultValue = outLenVal.slice(0, maxlen);
        }
        // 最大长度变更
        state.titleConfig.validations.maxLength = maxlen;
    },
    // 改变标题placeholder
    changeTitlePlaceholder(state, isIssue) {
        if (isIssue) {
            state.titleConfig.placeholder = state.issueTitlePlaceholder;
            return;
        }
        state.titleConfig.placeholder = state.notIssueTitlePlaceholder;
    },
    // 清除页面数据
    clearPageData(state) {
        state.extConfig = {};
        state.renderConfig = {};
        state.pageConfig = {};
        state.titleConfig.defaultValue = '';
        state.titleConfig.validations.maxLength = state.notIssueTitleLen;
        state.titleConfig.placeholder = state.notIssueTitlePlaceholder;
        state.activeTag = -1;
        state.activeTagIndex = 0;
        state.topicId = '';
        state.isInputSthing = false;
    },
    // 初始页面数据
    initPageConfig(state, {data, query}) {
        // extConfig为描述表
        state.extConfig = data.boardTag;
        // renderConfig为校验表
        state.renderConfig = data.extStyle;
        // pageConfig为当前页面描述表
        state.pageConfig = state.renderConfig;
        // 如果有tagId，定位到子标签
        if (query.tagId) {
            state.activeTag = +query.tagId;
            state.extConfig[0].tagInfo.forEach((item, index) => {
                if (item.id === state.activeTag) {
                    state.activeTagIndex = index;
                }
            });
            delete query.tagId;
        }
        // 没有默认定位首个标签
        else {
            state.activeTagIndex = 0;
            try {
                state.activeTag = data.boardTag[0].tagInfo[0].id;
            }
            catch (err) {
                state.activeTag = -1;
            }
        }

        if (Object.keys(query).length) {
            for (let key of Object.keys(query)) {
                // 有内容匹配页面内容
                if (state.pageConfig[key]) {
                    state.pageConfig[key].defaultValue = query[key];
                }
            }
        }
    },
    // 填充详细描述
    getContentPlaceholder(state) {
        if (state.routeName === 'addTopic') {
            if (state.extConfig[0].tagInfo.length) {
                let ext = state.extConfig[0].tagInfo[state.activeTagIndex].ext;
                if (Object.keys(ext).length) {
                    state.initPlaceholder = localStorage.getItem('contentPlaceholder') || ext.contentPlaceholder;
                    state.initPlaceholder = ext.placeholder;
                    if (ext.extBeanConfig && ext.extBeanConfig.length) {
                        for (let item of ext.extBeanConfig) {
                            if (item.placeholder
                                && state.renderConfig[item.template].defaultValue) {
                                let value = state.renderConfig[item.template].defaultValue;
                                state.initPlaceholder = item.placeholder[value];
                            }
                        }
                    }
                }
                else {
                    state.initPlaceholder = '';
                }
            }
            else {
                state.initPlaceholder = '';
            }
        }
    },
    // 切换标签
    changeTag(state, {id, idx}) {
        state.activeTag = id;
        state.activeTagIndex = idx;
    },
    // 设置帖子标签
    setTags(state, value) {
        state.dynamicTags = value;
    },
    addComponent(state, template) {
        if (state.finalExtName.indexOf(template) === -1) {
            state.finalExtName.push(template);
        }
        if (state.pageConfig[template] && state.pageConfig[template].defaultValue) {
            if (Array.isArray(state.pageConfig[template].defaultValue)) {
                state.pageConfig[template].defaultValue = [...state.renderConfig[template].defaultValue];
            }
            else {
                state.pageConfig[template].defaultValue = state.renderConfig[template].defaultValue;
            }
        }
    },
    removeComponent(state, template) {
        if (state.finalExtName.indexOf(template) > -1) {
            let idx = state.finalExtName.indexOf(template);
            state.finalExtName.splice(idx, 1);
        }
        if (state.pageConfig[template] && state.pageConfig[template].defaultValue) {
            state.pageConfig[template].defaultValue = state.renderConfig[template].defaultValue;
        }
    },
    // 校验页面信息是否存在空
    // 将页面内容组合成键值对形式传给后端
    comExtList(state, {content, pureText, contentMaxLen}) {
        state.hasNull = false;
        // 纯文本为空，但不拦住纯图片
        if (pureText.length === 0 && content.indexOf('img') === -1) {
            toast.info(Tip.existNull);
            // 检测到由必填字段没有填写，弹出提示框
            state.hasNull = true;
        }
        else {
            let result = {
                tagId: state.activeTag,
                title: state.titleConfig.defaultValue,
                content
            };
            if (state.extConfig[0].tagInfo
                && state.extConfig[0].tagInfo.length === 0) {
                result = {
                    title: state.titleConfig.defaultValue,
                    content
                };
            }
            else if (state.dynamicTags && state.dynamicTags.length) {
                result = {
                    tagId: state.activeTag,
                    title: state.titleConfig.defaultValue,
                    labels: state.dynamicTags,
                    content
                };
            }
            for (let key of Object.keys(result)) {
                if (result[key] < 0 || result[key].length === 0) {
                    toast.info(Tip.existNull);
                    state.hasNull = true;
                    break;
                }
            }
            let p = /<\/?.+?\/?>/g;
            let textLen = content.replace(p, matched => '').length;
            // 回复输入超过2000
            if (textLen > contentMaxLen) {
                state.hasNull = true;
                toast.info(`请输入不超过${contentMaxLen}个字符`);
            }
            else if (!state.hasNull && state.finalExtName.length > 0) {
                result.extBeanList = [];
                let hasCrashStackUrl;
                let hasCrashStackFile;
                for (let template of state.finalExtName) {
                    let obj = state.pageConfig[template];
                    if (obj.validations && obj.validations.required) {
                        // 有 validations 且 requeired 为 1
                        if (obj.defaultValue.length === 0 || obj.defaultValue < 0) {
                            state.hasNull = true;
                            toast.info(Tip.existNull);
                            break;
                        }
                    }
                    else {
                        // 上传文件后删除文件，defaultValue 属性为 null
                        if (template === 'crashStackFile' && obj.defaultValue == null) {
                            hasCrashStackFile = 0;
                            if (hasCrashStackFile == 0 && hasCrashStackUrl == 0) {
                                state.hasNull = true;
                                toast.info(Tip.existNull);
                                break;
                            }
                        }
                        if (obj.defaultValue !== null && obj.defaultValue.length === 0 || obj.defaultValue < 0) {
                            if (template === 'crashStackUrl') {
                                hasCrashStackUrl = 0;
                            }
                            if (template === 'crashStackFile') {
                                hasCrashStackFile = 0;
                            }
                            if (hasCrashStackFile === 0 && hasCrashStackUrl === 0) {
                                // 可能存在其中一个 undefined
                                state.hasNull = true;
                                toast.info(Tip.existNull);
                                break;
                            }
                            continue;
                        }
                    }
                    // 截图的内容仅上传图片 Url
                    if (template === 'screenShot') {
                        let imgSrcArray = obj.defaultValue.map(item => item.src);
                        let tmp = {
                            name: template,
                            value: imgSrcArray
                        };
                        result.extBeanList.push(tmp);
                    }
                    else if(template === 'crashStackUrl') {
                        hasCrashStackUrl = 1;
                        if (hasCrashStackFile) {
                            state.hasNull = true;
                            toast.info(Tip.crashStackContentError);
                            break;
                        }
                        let tmp = {
                            name: template,
                            value: obj.defaultValue
                        };
                        result.extBeanList.push(tmp);
                    }
                    else if (template === 'crashStackFile') {
                        if (obj.defaultValue !== null && hasCrashStackUrl) {
                            state.hasNull = true;
                            toast.info(Tip.crashStackContentError);
                            break;
                        }
                        if(obj.defaultValue !== null) {
                            let fileSrcArray = new Array(obj.defaultValue.src);
                            let tmp = {
                                name: template,
                                value: fileSrcArray
                            };
                            result.extBeanList.push(tmp);
                        }
                    }
                    else {
                        let tmp = {
                            name: template,
                            value: obj.defaultValue
                        };
                        result.extBeanList.push(tmp);
                    }
                }
            }
            if (state.topicId) {
                result.topicId = state.topicId;
            }
            state.finalResult = result;
        }
    },
    // 编辑页填充内容
    setExistContent(state, topicInfo) {
        state.activeTag = topicInfo.tagId;
        state.extConfig[0].tagInfo.forEach((item, index) => {
            if (item.id === state.activeTag) {
                state.activeTagIndex = index;
            }
        });
        state.titleConfig.defaultValue = topicInfo.title;
        state.dynamicTags = topicInfo.labels;
        state.initPlaceholder = topicInfo.content;
        for (let ext of topicInfo.extBeanList) {
            if (Array.isArray(ext.value)) {
                state.pageConfig[ext.name].defaultValue = [...ext.value];
            }
            else {
                state.pageConfig[ext.name].defaultValue = ext.value;
            }
        }
    },
    // 文本器有内容输入时，标识已有输入，不再清空文本器内容
    notChangeEditor(state) {
        if (!state.isInputSthing) {
            state.isInputSthing = true;
        }
    },
    setRouteName(state, routeName) {
        state.routeName = routeName;
    },
    setTopicId(state, topicId) {
        state.topicId = topicId;
    },
    setIsInputSthing(state, val) {
        state.isInputSthing = val;
    },
    setTitleSugList(state, list) {
        state.titleSugList = list;
    }
};
